module.exports = __webpack_public_path__ + "img/melon.554652ec.svg";